/**
 * Lightweight first-paint / boot timeline for diagnosing `/` vs `/debug`.
 * Writes no network traffic by itself — `reportClientError` merges a
 * compact copy into outbound payloads when something fails.
 */

export interface BootPhaseEntry {
  name: string;
  /** `performance.now()` relative to navigation start where available */
  atMs: number;
  /** Optional tiny bag — keep primitive / small arrays only */
  data?: Record<string, unknown>;
}

const PHASES_CAP = 64;
const phases: BootPhaseEntry[] = [];

/** Record once per boot phase — idempotent-ish (dup names allowed if spaced). */
export function recordBootPhase(
  name: string,
  data?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || typeof performance === 'undefined') {
    return;
  }
  const entry: BootPhaseEntry = {
    name,
    atMs: Math.round(performance.now()),
    ...(data ? { data } : {}),
  };
  phases.push(entry);
  if (phases.length > PHASES_CAP) {
    phases.splice(0, phases.length - PHASES_CAP);
  }
}

/** Chronological phases (trimmed oldest if over cap). */
export function getBootPhasesSnapshot(): BootPhaseEntry[] {
  return [...phases];
}

export function resetBootMilestonesForTests(): void {
  phases.length = 0;
}
